import React from 'react';
import { string,object,func } from 'prop-types';
import Loading from '../../atoms/Loading/index';
import CreateQuizContainer from '../../../containers/CreateQuizContainer';
import PlayQuizContainer from '../../../containers/PlayQuizContainer';
import SearchQuizContainer from '../../../containers/SearchQuizContainer';
import RecipeDetailContainer from '../../../containers/RecipeDetailContainer';
import ProfileContainer from '../../../containers/ProfileContainer';
import UserContainer from '../../../containers/UserContainer';
import LandingPageContainer from '../../../containers/LandingPageContainer';
import HomeContainer from '../../../containers//HomeContainer';
import TermsPage from '../../pages/TermPage';
import RedirectToSearchQuizContainer from '../../../containers/RedirectToSearchQuizContainer';
import PrivacyPolicyPage from '../../pages/PrivacyPolicyPage';
import Redirect from '../../atoms/Redirect';
import SingleContentLayout from '../../templates/SingleContentLayout';
import { AUTH } from '../../../constants';

const NotFound = () => <h3>404</h3>;

const Contents = {
	CreateQuiz: CreateQuizContainer,
	PlayQuiz: PlayQuizContainer,
	SearchQuiz: SearchQuizContainer,
	RecipeDetail: RecipeDetailContainer,
	Profile: ProfileContainer,
	User: UserContainer,
	LandingPage: LandingPageContainer,
	HomePage: HomeContainer,
	RedirectToSearch: RedirectToSearchQuizContainer,
	TermsPage,
	PrivacyPolicyPage,
	NotFound
};

const ContentPage = ({ auth, page, redirectToLandingPage }) => {
	if (auth.authStatus === AUTH.LOGIN_REQUEST || auth.authStatus === AUTH.NONE) {
		return <SingleContentLayout render={() => <Loading />} />;
	}
	const Component = Contents[page];
	if (auth.authStatus === AUTH.LOGGED_OUT) {
		if(page==='LandingPage' || page==='TermsPage' || page==='PrivacyPolicyPage'){
			return <Component />;
		}
		return <Redirect redirectTo={redirectToLandingPage} />;
	}
	return <Component />;
};

ContentPage.propTypes = {
	auth: object.isRequired,
	page: string.isRequired,
	redirectToLandingPage: func.isRequired
};

export default ContentPage;